import { render, staticRenderFns } from "./ScoopTask.vue?vue&type=template&id=ba2d7ab8&scoped=true&"
import script from "./ScoopTask.vue?vue&type=script&lang=js&"
export * from "./ScoopTask.vue?vue&type=script&lang=js&"
import style0 from "./ScoopTask.vue?vue&type=style&index=0&id=ba2d7ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2d7ab8",
  null
  
)

export default component.exports